/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: requesttypes.components.ts
 * Generated By : ianday on 12/12/23
 * Date ........: 12/12/23
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../../services/settings';
import { ServiceRequestType } from "../../../models/service-request-type";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import { ValidationResult } from '../../../models/validation-result';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';
import { ServiceDefService } from "../../../services/servicedef.service";
import { UnitOfMeasure } from "../../../models/unit-of-measure";
import { NotesComponent } from 'src/app/components/notes/notes.component';
import { MasterqualifyRequesttypeMappingComponent } from './drawer/masterqualify-requesttype-mapping/masterqualify-requesttype-mapping.component';

export class UOMRec {
	id: string;
	description: string;
	constructor(id: string, desc: string) {
		this.id = id;
		this.description = desc;
	}
}
@Component({
	selector: 'app-requesttypes',
	templateUrl: './requesttypes.component.html',
	styleUrls: ['./requesttypes.component.css']
})
export class RequestTypesComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Request Types';
	public pagination: string;
	
	public propContainerState: boolean | null = false;  /** set to false ***/
	public visiblePropertiesTab: boolean | null = true;
	public drawTabIndex: number | null = 0;

	@ViewChild('notes', { static: true }) notes: NotesComponent;
	@ViewChild('qualifymapping', { static: true }) qualifymapping: MasterqualifyRequesttypeMappingComponent;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: any;
	public selectedRecord: ServiceRequestType;
	public historyRecord: ServiceRequestType;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<any>;

	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;


	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'description', 'unitOfMeasure', 'baseDurationDays', 'externalReferral','defaultMembers', 'activeStatus'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;
	public visibleQualifications: boolean | null = false;
	public editableQualifications: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;

	public id: any | null = '';
	public description: any | null = '';
	public flatRequestField: any | null = '';
	public unitOfMeasure: any | null = '';
	public baseDurationDays: any | null = '';
	public activeStatus: any | null = '';
	public uomList: any;
	public externalReferral: any | null = 'No';
	public defaultMembers: any | null = 'All';

	public busyCursor: boolean = false;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	constructor(private serviceRequestsService: ServiceRequestsService,
		private serviceDefService: ServiceDefService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new ServiceRequestType();
	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_TYPES", "WRITE")) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleDelete = false;
		}
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_TYPE_QUALIFICATIONS", "READ")) {
			this.visibleQualifications = true;			
		}
		
	}

	ngAfterContentInit() {


		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}

		this.serviceDefService.getActiveUnitOfMeasures().subscribe(
			(result) => {
				this.uomList = new Array();
				for (const rec of result) {
					this.uomList.push(new UOMRec(rec.description, rec.description));
				}
				//this.uomList = result;
				this.queryRecords();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching UOMs')
			});
	}

	/*** Query Records from the Service ***/
	public queryRecords() {
		this.busyCursor = true;
		this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
			(result) => {
				this.busyCursor = false;
				this.records = result;

				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;

				this.setPagination(-1, this.dataSource.data.length);
				this.onChangeStatusFilterValue();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve request types data from the' +
					' service');
				this.busyCursor = false;
			}
		);
	}

	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}

	public onChangeStatusFilterValue() {
		const dataTemp: ServiceRequestType[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}

	public onStatusChange() {

		this.serviceRequestsService.updateRequestType(this.selectedRecord).subscribe(
			() => {
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue();
			});
	}

	public doTabChange(): void {

	}

	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if ((this.isEditing) || (this.qualifymapping.isEditing)){
			event.preventDefault();
			return;
		}

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}

	public applyFilter(filterValue: string) {
		if ((this.isEditing) || (this.qualifymapping.isEditing)){
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		this.displayDrawerData();
	}

	public unSelectRow() {
		this.Idx = -1;
		this.selectedRecord = new ServiceRequestType();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);
	}

	public displayDetail(record: ServiceRequestType) {
		if (record === undefined) {
			return;
		}
		this.id = record.id;
		this.description = record.description;
		this.flatRequestField = record.flatRequestField;
		this.unitOfMeasure = record.unitOfMeasure;
		this.baseDurationDays = record.baseDurationDays;
		this.activeStatus = record.activeStatus;
		this.externalReferral = record.externalReferral;
		this.defaultMembers = record.defaultMembers;
		this.history.onShowHandler('ServiceRequestTypes', 'id', record.id.toString());
	}

	public clear() {
		this.id = '';
		this.description = '';
		this.flatRequestField = '';
		this.unitOfMeasure = '';
		this.baseDurationDays = '';
		this.activeStatus = '';
		this.externalReferral = 'No';
		this.defaultMembers = 'A';
	}

	public addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (this.isAdd) {
			this.clear();
			this.id = 0;
			this.activeStatus = 'Active';
		} else {
			// store the history record
			this.historyRecord = this.selectedRecord;
		}

		DwUtils.setFocus('description');
	}

	public removeRecord() {
		const message = 'Remove Request Type: "' + this.selectedRecord.description + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.serviceRequestsService.deleteRequestType(this.selectedRecord.id).subscribe(
					() => {
						// remove the row from the table.

						this.records.splice(this.Idx, 1);
						this.dataSource.data = this.records;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}

	public tableKeyDown(event: KeyboardEvent) {
		if ((this.isEditing) || (this.qualifymapping.isEditing)){
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}

	public submitRecord() {

		this.selectedRecord = new ServiceRequestType();
		this.selectedRecord.id = this.id;
		this.selectedRecord.description = DwUtils.capitalize(this.description);
		this.selectedRecord.flatRequestField = this.flatRequestField;
		this.selectedRecord.unitOfMeasure = this.unitOfMeasure;
		this.selectedRecord.baseDurationDays = this.baseDurationDays;
		this.selectedRecord.activeStatus = this.activeStatus;
		this.selectedRecord.externalReferral = this.externalReferral;
		this.selectedRecord.defaultMembers = this.defaultMembers;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (this.isAdd === true) {
			this.serviceRequestsService.createRequestType(this.selectedRecord).subscribe(
				(result) => {
					this.selectedRecord.id = result.id;
					this.isEditing = false;
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('ServiceRequestTypes', this.selectedRecord.id);
				},
				() => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {

			this.serviceRequestsService.updateRequestType(this.selectedRecord).subscribe(
				() => {
					this.isEditing = false;
				},
				() => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'ServiceRequestTypes', this.selectedRecord.id);
		}
		this.updateSelectedRow();
	}

	/* Update the record in the table's data source - without refreshing it */
	public updateSelectedRow(): void {

		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.Idx = i;
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		}

		//this.dataSource.sort = this.sort;
	}

	public onRowClicked(selected: any) {

		if ((this.isEditing) || (this.qualifymapping.isEditing)){
			return;
		}

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.selectedRecord = this.historyRecord;
		this.displayDetail(this.selectedRecord);
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
		/** if the drawer is open - then select the data for the selected record if chosen **/
		/*if ((this.propContainerState === true) && (this.selectedCaseId > 0)) {
			this.pastAssistance.onShowHandler(this.selectedCaseId);
		} */
	}
	public doDrawerTabChange(event: any): void {

		this.drawTabIndex = event.index;
		this.displayDrawerData();

	}
	public displayDrawerData(): void {

		/** Note there are one or two tabs not reflected here **.
		 * they were taken out temporarily
		 **/
		switch (this.drawTabIndex) {
			case 1:
				this.notes.parentId = this.selectedRecord.id;
				this.notes.onShowHandler();
				break;
			case 0:
				this.qualifymapping.onShowHandler(this.selectedRecord.id);
				break;
		}
	}
}
